import React from 'react';
import ContentLayout from 'components/ContentLayout/SmartLayout';
import ReturnItoReturnR from 'components/Sales/Smart/MoveMerge/MoveWarehouse/ReturnItoReturnR';
import { getWarehouseCodeFromCache } from 'utils';
import { LS_DEFAULT_WAREHOUSE_KEY } from 'constants/config';

export default function Page(): JSX.Element {
  return (
    <ContentLayout 
    titleKey="titles.returnItoReturnR" value={getWarehouseCodeFromCache(Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY)))}

    // title={`From Return-Inspection to Return-Resalable(W#: ${getWarehouseCodeFromCache(Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY)))})`}
    >
      <ReturnItoReturnR />
    </ContentLayout>
  );
}


